import CreateAction from './createAction';

export const uploadImage = async (file: FormData, hideToastMessages?: boolean) => {
    const response = await CreateAction({
        method: "post",
        path: `/upload`,
        showPreLoader: true,
        isFileUploading: true,
        hideToastMessages,
        data: file
    }
    );

    if (!response.error) {
        return (response)
    }

}